import { makeStyles, TTheme } from '@rbx/ui';
import { getEngineRevampParagraphStyle } from '@modules/ui/shared/utils/styles';

/**
 * Styles for collapsed breadcrumb icon (mobile view)
 */
export const getCollapsedIconStyles = (theme: TTheme) => ({
  backgroundColor: theme.palette.surface[0],
  color: `${theme.palette.content.action}`,
});

/**
 * Styles for the sticky breadcrumb component
 */
const useReferenceStickyBreadcrumbStyles = makeStyles()((theme) => ({
  container: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.surface[0],
    zIndex: 1000,
    paddingBottom: '8px',
  },
  breadcrumbRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    paddingBottom: '16px',
  },
  divider: {
    borderBottomWidth: '1px',
  },
  breadcrumbContainer: {
    flexGrow: 1,
    overflow: 'hidden',
    minWidth: 0,
  },
  breadcrumbLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: theme.palette.content.action,
    },
  },
  currentPageLink: {
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: theme.palette.content.muted,
    },
  },
  breadcrumbText: {
    ...getEngineRevampParagraphStyle(theme),
    fontWeight: 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  parentItem: {
    color: theme.palette.content.action,
  },
  tocIcon: {
    color: theme.palette.content.standard,
  },
  // Container for right side content (TOC icon and action buttons)
  rightSideContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    position: 'relative', // Allows TOC icon to overlay action buttons
  },
  // Action buttons (Language, Feedback, Edit) shown on desktop when TOC is not scrolled
  actionButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
    transition: 'opacity 0.2s ease-in-out',
  },
  // TOC icon container
  tocIconContainer: {
    display: 'flex',
    alignItems: 'center',
    transition: 'opacity 0.2s ease-in-out',
  },
  // Hidden state - completely removes from layout
  hidden: {
    display: 'none',
  },
}));

export default useReferenceStickyBreadcrumbStyles;
